export const localeShow = [
  "en",
  "ru",
  "es",
  "pt",
  "ms",
  "vi",
  "fr",
  "de",
  "ar",
  "id",
  "th",
  "ko",
  "ja",
  "nl",
  "it",
  "sv",
  "uk",
  "zh",
  "he",
  "hi",
  "tl",
  "cs",
  "pl",
  "no",
  "tr",
  "da",
  "jw",
  "ur",

];
export let url = window.location.pathname;
export let cokkiLocale = document.cookie.replace(
  /(?:(?:^|.*;\s*)user_local\s*\=\s*([^;]*).*$)|^.*$/,
  "$1"
);
